<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="cotacoes.content"
      class="mt-5"
      :loading="loading"
      :server-items-length="cotacoes.total"
      @update:options="updateOptions"
      :footer-props="footerOptions"
      no-data-text="Nenhuma cotação encontrada"
      loading-text="Carregando cotações..."
      :options="optionsList"
    >
      <template v-slot:item.id="{ item }">
        <div class="text-left">
          <px-span-tooltip
            bottom
            :text="`${item.cotacao.id} / ${item.id}`"
            tooltip="Código da cotação / código da solicitação"/>
        </div>
      </template>
      <template v-slot:item.comprador="{ item }">
        <px-situacao-solicitacao-icon :situacao="item.situacaoSolicitacaoResposta"/>
        {{ item.nomeCliente }}
        <px-status-negociacao
          :status-negociacao="statusNegociacao(item)"/>
      </template>
      <template v-slot:item.createdIn="{ item }">
        {{ createdIn(item) | date }}
      </template>
      <template v-slot:item.quantidadeProdutos="{ item }">
        {{ quantidadeProdutos(item) }} produto(s)
      </template>
      <template v-slot:item.cotacao.situacao="{ item }">
        <px-situacao-cotacao is-view-fornecedor :situacao="situacao(item)"/>
      </template>
      <template v-slot:item.options="{ item }">
        <v-btn icon link :to="toCotacao(item)">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on"
                   link
                   :to="`cotacao/${item.id}/feedback`"
                   :disabled="!isFinalizada(item) || !isRespondida(item)">
              <v-icon>mdi-clipboard-list-outline</v-icon>
            </v-btn>
          </template>
          <span>Ver feedback</span>
        </v-tooltip>
        <!--        <px-feedback :solicitacao-id="item.id">-->
        <!--          <template v-slot:activator="{ on }">-->
        <!--            <v-tooltip bottom>-->
        <!--              <template v-slot:activator="{ on: onTooltip }">-->
        <!--                <v-btn icon v-on="{ ...onTooltip, ...on }"-->
        <!--                       :disabled="!isFinalizada(item) || !isRespondida(item)">-->
        <!--                  <v-icon>mdi-clipboard-list-outline</v-icon>-->
        <!--                </v-btn>-->
        <!--              </template>-->
        <!--              <span>Ver feedback</span>-->
        <!--            </v-tooltip>-->
        <!--          </template>-->
        <!--        </px-feedback>-->
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { SituacaoCotacao, SituacaoSolicitacaoResposta, TipoSolicitacao } from 'px-business-components';

export default {
  props: {
    cotacoes: Object,
    default: [],
    loading: Boolean,
    onChangeOptions: {
      type: Function,
      required: true,
    },
    optionsList: Object,
  },
  data() {
    return {
      footerOptions: {
        itemsPerPageOptions: [5, 10, 15, 20],
        itemsPerPageText: 'Linhas por página',
      },
      headers: [
        {
          text: 'Código',
          value: 'id',
          sortable: false,
        },
        {
          text: 'Cliente',
          value: 'comprador',
        },
        {
          text: 'Data de entrada',
          value: 'createdIn',
        },
        {
          text: 'Situação da cotação',
          value: 'cotacao.situacao',
        },
        {
          text: 'Produtos',
          sortable: false,
          value: 'quantidadeProdutos',
        },
        {
          text: null,
          sortable: false,
          value: 'options',
        },
      ],
    };
  },
  computed: {
    isFinalizada() {
      return (item) => item.cotacao
        && item.cotacao.situacao === SituacaoCotacao.keys.FINALIZADA.key;
    },
    isRespondida() {
      return (item) => item.situacaoSolicitacaoResposta
        === SituacaoSolicitacaoResposta.keys.RESPONDIDA.key;
    },
    createdIn() {
      return (item) => {
        if (item.tipoSolicitacaoResposta === TipoSolicitacao.keys.COTACAO.key) {
          return item.cotacao.createdIn;
        }
        return item.cotacaoConjunta.createdIn;
      };
    },
    statusNegociacao() {
      return (item) => {
        if (item.tipoSolicitacaoResposta === TipoSolicitacao.keys.COTACAO.key) {
          return item.respostaCotacao ? item.respostaCotacao.statusNegociacao : null;
        }
        return item.respostaCotacaoConjunta ? item.respostaCotacaoConjunta.statusNegociacao : null;
      };
    },
    situacao() {
      return (item) => {
        if (item.tipoSolicitacaoResposta === TipoSolicitacao.keys.COTACAO.key) {
          return item.cotacao.situacao;
        }
        return item.cotacaoConjunta.situacao;
      };
    },
    quantidadeProdutos() {
      return (item) => {
        if (item.tipoSolicitacaoResposta === TipoSolicitacao.keys.COTACAO.key) {
          return item.cotacao.quantidadeProdutos;
        }
        return item.cotacaoConjunta.quantidadeProdutos;
      };
    },
    toCotacao() {
      return (item) => {
        if (item.tipoSolicitacaoResposta === TipoSolicitacao.keys.COTACAO.key) {
          return `cotacao/${item.id}`;
        }
        return `cotacao-conjunta/${item.id}`;
      };
    },
  },
  methods: {
    updateOptions(options) {
      this.onChangeOptions(options);
    },
    emitUpdate() {
      this.$emit('update');
    },
  },
};
</script>
